module.exports = __webpack_public_path__ + "img/Bitmap@2x123.bc2925a6.png";